    export function isJsObject(o) {
        return o !== null && (typeof o === 'function' || typeof o === 'object');
    }

    /**
     * Converts an object to a parametrised string.
     * @param object
     * @returns {string}
     */
    export function objectToParams(object): string {
        if (!object) {
            return '';
        }

        return Object.keys(object).map((key) => isJsObject(object[key]) ?
            subObjectToParams(encodeURIComponent(key), object[key]) :
            `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`
        ).join('&');
    }

    /**
     * Converts a sub-object to a parametrised string.
     * @param object
     * @returns {string}
     */
    function subObjectToParams(key, object): string {
        if (!object) {
            return '';
        }

        return Object.keys(object).map((childKey) => isJsObject(object[childKey]) ?
                subObjectToParams(`${key}[${encodeURIComponent(childKey)}]`, object[childKey]) :
                `${key}.${encodeURIComponent(childKey)}=${encodeURIComponent(object[childKey])}`
        ).join('&');
    }

    export function toNetTime(parameter: string): string {
        return '\/Date(' + new Date(parameter).getTime() + ')\/';
    }

    export function toNetParameterDate(parameter: Date): string {
        return parameter.getFullYear() + '-' + (parameter.getMonth() + 1) + '-' + parameter.getDate();
    }

    export function toLocalTime(d: Date): string {
        return d.getDate() + '.' + (d.getMonth() + 1) + '.' + d.getFullYear() + ' ' +
               padLeft(d.getHours(), 2) + ':' + padLeft(d.getMinutes(), 2) + ':' + padLeft(d.getSeconds(), 2) + ' (CET)';
    }

    export function toLocalTimeShort(d: Date): string {
        return d.getDate() + '.' + (d.getMonth() + 1) + '.' + d.getFullYear() + ' ' +
               padLeft(d.getHours(), 2) + ':' + padLeft(d.getMinutes(), 2) + ':' + padLeft(d.getSeconds(), 2);
    }

    Object.defineProperty(Object.prototype, 'getProp', {
        value: function (prop) {
            let key, self = this;
            for (key in self) {
                if (key.toLowerCase() === prop.toLowerCase()) {
                    return self[key];
                }
            }
        },
        // this keeps jquery happy
        enumerable: false
    });


    export function padLeft(input: Number, length: number, str: string = null) {
        return Array(length - String(input).length + 1).join(str || '0') + input;
    }

    export function createGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            // tslint:disable-next-line:no-bitwise
            let r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    /*
     * GroupBy
     * console.log(groupBy(['one', 'two', 'three'], 'length'));
     * // => {3: ["one", "two"], 5: ["three"]}
    */
    export function groupBy(xs, key) {
        return xs.reduce(function(rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/common/functions.ts